const Footer = () => {
  return (
    <footer className="footer">
      {/* <nav className="footer-nav">
        <ul className="footer-list">
          <li className="footer-item">
            <a href="/" className="footer-link">
              トップ
            </a>
          </li>
          <li className="footer-item">
            <a href="/contact" className="footer-link">
              ご意見箱・お問い合わせ
            </a>
          </li>
        </ul>
      </nav> */}
      <p className="footer-copyright">
        &copy; 2025 Comodo Apps
      </p>
    </footer>
  );
};

export default Footer;
